import React, { useState } from 'react';
import * as _ from 'lodash';
import { __ } from '../../core/utils';
import Button from '../../components/Button';
import ButtonGroup from '../../components/ButtonGroup';
import Input from '../../components/Input';
import Select from '../../components/Select';
import styles from '../../styles/forms/timesheets/TimesheetReportExportForm.scss';

const TimesheetReportExportForm = ({
  exportMonth,
  exportYear,
  onMonthChange,
  onYearChange,
  onClose,
  onSubmit,
}) => {
  const [activeField, setActiveField] = useState(null);
  const [touchedFields, setTouchedFields] = useState({});

  const monthOptions = [
    { value: '1', label: __('timesheet-report-export-modal-january') },
    { value: '2', label: __('timesheet-report-export-modal-february') },
    { value: '3', label: __('timesheet-report-export-modal-march') },
    { value: '4', label: __('timesheet-report-export-modal-april') },
    { value: '5', label: __('timesheet-report-export-modal-may') },
    { value: '6', label: __('timesheet-report-export-modal-june') },
    { value: '7', label: __('timesheet-report-export-modal-july') },
    { value: '8', label: __('timesheet-report-export-modal-august') },
    { value: '9', label: __('timesheet-report-export-modal-september') },
    { value: '10', label: __('timesheet-report-export-modal-october') },
    { value: '11', label: __('timesheet-report-export-modal-november') },
    { value: '12', label: __('timesheet-report-export-modal-december') },
  ];

  const errors = {
    month: !exportMonth
      ? [__('timesheet-report-export-field-required')]
      : undefined,
    year: !exportYear
      ? [__('timesheet-report-export-field-required')]
      : !/^\d{4}$/.test(String(exportYear))
      ? [__('Year must have 4 digits')]
      : undefined,
  };

  const hasErrors = _.some(errors);

  const _touchField = (field) => {
    setTouchedFields((prevState) => ({
      ...prevState,
      [field]: true,
    }));
  };

  const _handleSubmit = () => {
    setTouchedFields({
      month: true,
      year: true,
    });

    if (hasErrors) {
      return;
    }

    onSubmit();
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.form}>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Select
              input={{
                value: exportMonth,
                onChange: onMonthChange,
                onFocus: () => setActiveField('month'),
                onBlur: () => {
                  setActiveField(null);
                  _touchField('month');
                },
              }}
              meta={{
                active: activeField === 'month',
                touched: touchedFields.month,
                error: errors.month,
              }}
              label={__('timesheet-report.export.month')}
              options={monthOptions}
              noSort
              searchable
              top={28}
            />
          </div>
        </div>

        <div className={styles.flex}>
          <div className={styles.f1}>
            <Input
              input={{
                value: exportYear,
                onChange: onYearChange,
                onFocus: () => setActiveField('year'),
                onBlur: () => {
                  setActiveField(null);
                  _touchField('year');
                },
              }}
              meta={{
                active: activeField === 'year',
                touched: touchedFields.year,
                error: errors.year,
              }}
              label={__('timesheet-report.export.year')}
              numeric
              maxLength={4}
            />
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={onClose}
        />
        <ButtonGroup>
          <Button
            lightBlue
            medium
            middleText={__('button.export')}
            onClick={_handleSubmit}
          />
        </ButtonGroup>
      </div>
    </div>
  );
};

export default TimesheetReportExportForm;
